module.exports = __webpack_public_path__ + "static/media/connect.60db9638.jpg";